<div class="app-payment-additional-info" *ngIf="payment.hasAdditionalInfo">
  <p class="app-payment-additional-info-title" translate>payment.additionalInformation</p>

  <app-collapse [headerKey]="'payment.payerInfo.title'" [active]="false" *ngIf="payment.hasPayerInfo">
    <dl *ngIf="payment.payerNationality">
      <dt translate>payment.receiverInfo.payerNationality.label</dt>
      <dd>{{ payment.payerNationality | country}}</dd>
    </dl>
    <dl *ngIf="payment.payerRegistrationDate">
      <dt translate>payment.receiverInfo.payerRegistrationDate.label</dt>
      <dd>{{ payment.payerRegistrationDate }}</dd>
    </dl>
    <dl *ngIf="payment.payerBirthDate && !payment.payerIdentificationType">
      <dt translate>payment.identification.birthDate.label</dt>
      <dd>{{ payment.payerBirthDate }}</dd>
    </dl>
    <app-collapse [headerKey]="'payment.payerInfo.address.title'" *ngIf="payment.hasPayerAddressInfo || payment.sendPayerAddress">
      <ng-container *ngIf="payment.hasPayerAddressInfo">
        <ng-container *ngIf="payment.payerCountry">
          <dl>
            <dt translate>payment.payerInfo.address.country.label</dt>
            <dd>{{ payment.payerCountry | country }}</dd>
          </dl>
          <dl *ngIf="payment.payerProvince">
            <dt translate>payment.receiverInfo.address.province.label</dt>
            <dd>{{ payment.payerProvince }}</dd>
          </dl>
          <dl *ngIf="payment.payerCity">
            <dt translate>payment.receiverInfo.address.city.label</dt>
            <dd>{{ payment.payerCity }}</dd>
          </dl>
          <dl *ngIf="payment.payerStreetName">
            <dt translate>payment.receiverInfo.address.street.label</dt>
            <dd>{{ payment.payerStreetName }}</dd>
          </dl>
          <dl *ngIf="payment.payerBuildingName">
            <dt translate>payment.receiverInfo.address.buildingName.label</dt>
            <dd>{{ payment.payerBuildingName }}</dd>
          </dl>
          <dl *ngIf="payment.payerBuildingNumber">
            <dt translate>payment.receiverInfo.address.buildingNumber.label</dt>
            <dd>{{ payment.payerBuildingNumber }}</dd>
          </dl>
          <dl *ngIf="payment.payerPostalCode">
            <dt translate>payment.receiverInfo.address.postalCode.label</dt>
            <dd>{{ payment.payerPostalCode }}</dd>
          </dl>
        </ng-container>
        <dl *ngIf="payment.payerAddress">
          <dt translate>payment.payerInfo.address.address.label</dt>
          <dd>{{ payment.payerAddress }}</dd>
        </dl>
      </ng-container>
      <dl *ngIf="payment.sendPayerAddress">
        <dt translate>payment.payerInfo.paymentIdentification.sendPayerAddress.label</dt>
        <dd>{{ payment.sendPayerAddress | yesNo }}</dd>
      </dl>
    </app-collapse>

    <app-collapse [headerKey]="'payment.payerInfo.paymentIdentification.title'" *ngIf="payment.hasPaymentIdentificationInfo">
      <dl *ngIf="payment.paymentIdentification">
        <dt translate>payment.payerInfo.paymentIdentification.id.label</dt>
        <dd>{{ payment.paymentIdentification }}</dd>
      </dl>
      <ng-container *ngIf="payment.purposeCode">
        <dl>
          <dt translate>payment.receiverInfo.purposeCode.label</dt>
          <dd *ngIf="isTranslatable(payment.purposeCode, PurposeCode); else untranslatedPurposeCode">
            {{ 'payment.receiverInfo.purposeCode.classifier.' + payment.purposeCode | translate: locale.language }}
          </dd>
        </dl>
        <ng-template #untranslatedPurposeCode>
          <dl>
            <dd>{{ payment.purposeCode }}</dd>
          </dl>
        </ng-template>
      </ng-container>
    </app-collapse>

    <app-collapse [headerKey]="'payment.payerInfo.payerIdentification.title'" *ngIf="payment.hasPayerIdentificationInfo">
      <app-payment-additional-info-identification
        [identification]="payment.payerIdentification"
        [identificationType]="payment.payerIdentificationType"
        [identificationCodeType]="payment.payerIdentificationCodeType"
        [id]="payment.payerId"
        [identificationIssueCountry]="payment.payerIdentificationIssueCountry"
        [identificationIssueDate]="payment.payerIdentificationIssueDate"
        [identificationExpiryDate]="payment.payerIdentificationExpiryDate"
        [birthDate]="payment.payerBirthDate"
        [countryOfBirth]="payment.payerCountryOfBirth"
        [provinceOfBirth]="payment.payerProvinceOfBirth"
        [cityOfBirth]="payment.payerCityOfBirth"
      ></app-payment-additional-info-identification>
    </app-collapse>

    <app-collapse [headerKey]="'payment.payerInfo.initial.title'" *ngIf="payment.hasInitialPayerInfo">
      <dl *ngIf="payment.initialPayerName">
        <dd>{{ payment.initialPayerName }}</dd>
      </dl>

      <dl *ngIf="payment.initialPayerPhoneNumber">
        <dt translate>payment.receiverInfo.initialPayerPhoneNumber.label</dt>
        <dd>{{ payment.initialPayerPhoneNumber }}</dd>
      </dl>
      <dl *ngIf="payment.initialPayerEmail">
        <dt translate>payment.receiverInfo.initialPayerEmail.label</dt>
        <dd>{{ payment.initialPayerEmail }}</dd>
      </dl>

      <app-collapse [headerKey]="'payment.payerInfo.identify.title'" *ngIf="payment.hasInitialPayerIdentificationInfo">
        <app-payment-additional-info-identification
          [identification]="payment.initialPayerIdentification"
          [identificationType]="payment.initialPayerIdentificationType"
          [identificationCodeType]="payment.initialPayerIdentificationCodeType"
          [identificationLegalEntityIdentifier]="payment.initialPayerLegalEntityIdentifier"
          [identificationBic]="payment.initialPayerBic"
          [id]="payment.initialPayerId"
          [birthDate]="payment.initialPayerBirthDate"
          [countryOfBirth]="payment.initialPayerCountryOfBirth"
          [provinceOfBirth]="payment.initialPayerProvinceOfBirth"
          [cityOfBirth]="payment.initialPayerCityOfBirth"
        ></app-payment-additional-info-identification>
      </app-collapse>

      <app-collapse *ngIf="payment.hasInitialPayerIdentificationAddressInfo" [headerKey]="'payment.payerInfo.initial.address.title'">
        <dl *ngIf="payment.initialPayerCountry">
          <dt translate>payment.receiverInfo.address.country.label</dt>
          <dd>{{ payment.initialPayerCountry | country }}</dd>
        </dl>
        <dl *ngIf="payment.initialPayerProvince">
          <dt translate>payment.receiverInfo.address.province.label</dt>
          <dd>{{ payment.initialPayerProvince }}</dd>
        </dl>
        <dl *ngIf="payment.initialPayerCity">
          <dt translate>payment.receiverInfo.address.city.label</dt>
          <dd>{{ payment.initialPayerCity }}</dd>
        </dl>
        <dl *ngIf="payment.initialPayerStreetName">
          <dt translate>payment.receiverInfo.address.street.label</dt>
          <dd>{{ payment.initialPayerStreetName }}</dd>
        </dl>
        <dl *ngIf="payment.initialPayerBuildingName">
          <dt translate>payment.receiverInfo.address.buildingName.label</dt>
          <dd>{{ payment.initialPayerBuildingName }}</dd>
        </dl>
        <dl *ngIf="payment.initialPayerBuildingNumber">
          <dt translate>payment.receiverInfo.address.buildingNumber.label</dt>
          <dd>{{ payment.initialPayerBuildingNumber }}</dd>
        </dl>
        <dl *ngIf="payment.initialPayerPostalCode">
          <dt translate>payment.receiverInfo.address.postalCode.label</dt>
          <dd>{{ payment.initialPayerPostalCode }}</dd>
        </dl>
      </app-collapse>
    </app-collapse>
  </app-collapse>

  <app-collapse [headerKey]="'payment.receiverInfo.title'" [active]="collapseActive" *ngIf="payment.hasReceiverInfo">
    <ng-container *ngIf="payment?.hasReceiverIdentificationInfo">
      <p class="app-payment-additional-info-beneficiary-title" translate>payment.receiverInfo.beneficiary.title</p>
      <ng-container *ngTemplateOutlet="beneficiaryIdentificationBlock"></ng-container>
    </ng-container>
    <dl *ngIf="payment.beneficiaryAccountType">
      <dt translate>payment.receiverInfo.beneficiaryAccountType.label</dt>
      <dd *ngIf="isTranslatable(payment.beneficiaryAccountType, AccountType); else untranslatedAccountType">
        {{ 'payment.receiverInfo.beneficiaryAccountType.classifier.' + payment.beneficiaryAccountType | translate: locale.language }}
      </dd>
      <ng-template #untranslatedAccountType>
        <dd>{{ payment.beneficiaryAccountType }}</dd>
      </ng-template>
    </dl>
    <dl *ngIf="payment.beneficiaryNationality">
      <dt translate>payment.receiverInfo.beneficiaryNationality.label</dt>
      <dd>{{ payment.beneficiaryNationality | country }}</dd>
    </dl>
    <dl *ngIf="payment.beneficiaryRegistrationCountry">
      <dt translate>payment.receiverInfo.beneficiaryRegistrationCountry.label</dt>
      <dd>{{ payment.beneficiaryRegistrationCountry | country}}</dd>
    </dl>

    <dl *ngIf="payment.beneficiaryPhoneNumber">
      <dt translate>payment.receiverInfo.beneficiaryPhoneNumber.label</dt>
      <dd>{{ payment.beneficiaryPhoneNumber }}</dd>
    </dl>
    <dl *ngIf="payment.beneficiaryEmail">
      <dt translate>payment.receiverInfo.beneficiaryEmail.label</dt>
      <dd>{{ payment.beneficiaryEmail }}</dd>
    </dl>
    <app-collapse [headerKey]="'payment.receiverInfo.address.title'" [active]="collapseActive" *ngIf="payment.hasReceiverAddressInfo">
      <dl *ngIf="payment.beneficiaryCountry">
        <dt translate>payment.receiverInfo.address.country.label</dt>
        <dd>{{ payment.beneficiaryCountry | country }}</dd>
        <dd *ngIf="shouldShowSuggestion(payment.beneficiaryCountry, suggestedBeneficiaryAddress?.address?.country)" class="suggestion-underline">
          <app-image name="alert-circle" class="danger-icon"></app-image> <span translate>payment.suggestion</span>: {{
          suggestedBeneficiaryAddress?.address?.country | country }}
        </dd>
      </dl>
      <dl *ngIf="payment.beneficiaryProvince">
        <dt translate>payment.receiverInfo.address.province.label</dt>
        <dd>{{ payment.beneficiaryProvince }}</dd>
        <dd *ngIf="shouldShowSuggestion(payment.beneficiaryProvince, suggestedBeneficiaryAddress?.address?.countrySubDivision)" class="suggestion-underline">
          <app-image name="alert-circle" class="danger-icon"></app-image> <span translate>payment.suggestion</span>: {{
          suggestedBeneficiaryAddress?.address?.countrySubDivision }}
        </dd>
      </dl>
      <dl *ngIf="payment.beneficiaryCity">
        <dt translate>payment.receiverInfo.address.city.label</dt>
        <dd>{{ payment.beneficiaryCity }}</dd>
        <dd *ngIf="shouldShowSuggestion(payment.beneficiaryCity, suggestedBeneficiaryAddress?.address?.city)" class="suggestion-underline">
          <app-image name="alert-circle" class="danger-icon"></app-image> <span translate>payment.suggestion</span>: {{
          suggestedBeneficiaryAddress?.address?.city }}
        </dd>
      </dl>
      <dl *ngIf="payment.beneficiaryStreetName">
        <dt translate>payment.receiverInfo.address.street.label</dt>
        <dd>{{ payment.beneficiaryStreetName }}</dd>
        <dd *ngIf="shouldShowSuggestion(payment.beneficiaryStreetName, suggestedBeneficiaryAddress?.address?.street)" class="suggestion-underline">
          <app-image name="alert-circle" class="danger-icon"></app-image> <span translate>payment.suggestion</span>: {{
          suggestedBeneficiaryAddress?.address?.street }}
        </dd>
      </dl>
      <dl *ngIf="payment.beneficiaryBuildingName">
        <dt translate>payment.receiverInfo.address.buildingName.label</dt>
        <dd>{{ payment.beneficiaryBuildingName }}</dd>
        <dd *ngIf="shouldShowSuggestion(payment.beneficiaryBuildingName, suggestedBeneficiaryAddress?.address?.buildingName)" class="suggestion-underline">
          <app-image name="alert-circle" class="danger-icon"></app-image> <span translate>payment.suggestion</span>: {{
          suggestedBeneficiaryAddress?.address?.buildingName }}
        </dd>
      </dl>
      <dl *ngIf="payment.beneficiaryBuildingNumber">
        <dt translate>payment.receiverInfo.address.buildingNumber.label</dt>
        <dd>{{ payment.beneficiaryBuildingNumber }}</dd>
        <dd *ngIf="shouldShowSuggestion(payment.beneficiaryBuildingNumber, suggestedBeneficiaryAddress?.address?.buildingNumber)" class="suggestion-underline">
          <app-image name="alert-circle" class="danger-icon"></app-image> <span translate>payment.suggestion</span>: {{
          suggestedBeneficiaryAddress?.address?.buildingNumber }}
        </dd>
      </dl>
      <dl *ngIf="payment.beneficiaryPostalCode">
        <dt translate>payment.receiverInfo.address.postalCode.label</dt>
        <dd>{{ payment.beneficiaryPostalCode }}</dd>
        <dd *ngIf="shouldShowSuggestion(payment.beneficiaryPostalCode, suggestedBeneficiaryAddress?.address?.postCode)" class="suggestion-underline">
          <app-image name="alert-circle" class="danger-icon"></app-image> <span translate>payment.suggestion</span>: {{
          suggestedBeneficiaryAddress?.address?.postCode }}
        </dd>
      </dl>
      <dl *ngIf="payment.beneficiaryAddress">
        <dt translate>payment.receiverInfo.address.address.label</dt>
        <dd>{{ payment.beneficiaryAddress }}</dd>
        <dd *ngIf="shouldShowSuggestion(payment.beneficiaryAddress, suggestedBeneficiaryAddress?.address?.addressLine)" class="suggestion-underline">
          <app-image name="alert-circle" class="danger-icon"></app-image> <span translate>payment.suggestion</span>: {{
          suggestedBeneficiaryAddress?.address?.addressLine }}
        </dd>
      </dl>
    </app-collapse>

    <app-collapse [headerKey]="'payment.receiverInfo.correspondentBank.title'" *ngIf="payment.hasReceiverCorrespondentBankInfo">
      <dl *ngIf="payment.correspondentBankCode">
        <dt>{{ correspondentBankCodeLabel }}</dt>
        <dd>{{ payment.correspondentBankCode }}</dd>
      </dl>

      <dl *ngIf="payment.correspondentBankName">
        <dt translate>payment.receiverInfo.correspondentBank.name.label</dt>
        <dd>{{ payment.correspondentBankName }}</dd>
      </dl>

      <dl *ngIf="payment.correspondentBankCountry">
        <dt translate>payment.receiverInfo.correspondentBank.country.label</dt>
        <dd>{{ payment.correspondentBankCountry | country }}</dd>
      </dl>

      <dl *ngIf="payment.correspondentBankAddress">
        <dt translate>payment.receiverInfo.correspondentBank.address.label</dt>
        <dd>{{ payment.correspondentBankAddress }}</dd>
      </dl>

      <dl *ngIf="payment.correspondentBankIdentifier">
        <dt translate>payment.receiverInfo.correspondentBank.identifier.label</dt>
        <dd>{{ payment.correspondentBankIdentifier }}</dd>
      </dl>

      <ng-container *ngIf="payment.hasReceiverAdditionalCorrespondentBankInfo">
        <dl *ngIf="payment.accountWithBankCorrespondent">
          <dt translate>payment.receiverInfo.correspondentBank.account.label</dt>
          <dd>{{ payment.accountWithBankCorrespondent }}</dd>
        </dl>

        <dl *ngIf="payment.additionalBeneficiaryCorrespondentBankCodeType">
          <dt translate>payment.receiverInfo.additionalBankIdentification.additionalCorrespondentBankCodeType.label</dt>
          <dd>{{ payment.additionalBeneficiaryCorrespondentBankCodeType | bankCodeType }}</dd>
        </dl>

        <dl *ngIf="payment.additionalBeneficiaryCorrespondentBankCode">
          <dt translate>payment.receiverInfo.additionalBankIdentification.additionalCorrespondentBankCode.label</dt>
          <dd>{{ payment.additionalBeneficiaryCorrespondentBankCode }}</dd>
        </dl>
      </ng-container>
    </app-collapse>
  </app-collapse>

  <app-collapse [headerKey]="'payment.receiverInfo.ultimate.title'" *ngIf="payment.hasUltimateReceiverInfo">
    <dl *ngIf="payment.ultimateBeneficiaryName">
      <dd>{{ payment.ultimateBeneficiaryName }}</dd>
    </dl>

    <dl *ngIf="payment.ultimateBeneficiaryPhoneNumber">
      <dt translate>payment.receiverInfo.ultimateBeneficiaryPhoneNumber.label</dt>
      <dd>{{ payment.ultimateBeneficiaryPhoneNumber }}</dd>
    </dl>
    <dl *ngIf="payment.ultimateBeneficiaryEmail">
      <dt translate>payment.receiverInfo.ultimateBeneficiaryEmail.label</dt>
      <dd>{{ payment.ultimateBeneficiaryEmail }}</dd>
    </dl>

    <app-collapse [headerKey]="'payment.receiverInfo.identify.title'" *ngIf="payment.hasUltimateReceiverIdentificationInfo">
      <app-payment-additional-info-identification
        [identification]="payment.ultimateBeneficiaryIdentification"
        [identificationType]="payment.ultimateBeneficiaryIdentificationType"
        [identificationCodeType]="payment.ultimateBeneficiaryIdentificationCodeType"
        [identificationLegalEntityIdentifier]="payment.ultimateBeneficiaryLegalEntityIdentifier"
        [identificationBic]="payment.ultimateBeneficiaryBic"
        [id]="payment.ultimateBeneficiaryId"
        [birthDate]="payment.ultimateBeneficiaryBirthDate"
        [countryOfBirth]="payment.ultimateBeneficiaryCountryOfBirth"
        [provinceOfBirth]="payment.ultimateBeneficiaryProvinceOfBirth"
        [cityOfBirth]="payment.ultimateBeneficiaryCityOfBirth"
      ></app-payment-additional-info-identification>
    </app-collapse>
    <app-collapse *ngIf="payment.hasUltimateReceiverAddressInfo" [headerKey]="'payment.receiverInfo.ultimate.address.title'">
      <dl *ngIf="payment.ultimateBeneficiaryCountry">
        <dt translate>payment.receiverInfo.address.country.label</dt>
        <dd>{{ payment.ultimateBeneficiaryCountry | country }}</dd>
      </dl>
      <dl *ngIf="payment.ultimateBeneficiaryProvince">
        <dt translate>payment.receiverInfo.address.province.label</dt>
        <dd>{{ payment.ultimateBeneficiaryProvince }}</dd>
      </dl>
      <dl *ngIf="payment.ultimateBeneficiaryCity">
        <dt translate>payment.receiverInfo.address.city.label</dt>
        <dd>{{ payment.ultimateBeneficiaryCity }}</dd>
      </dl>
      <dl *ngIf="payment.ultimateBeneficiaryStreetName">
        <dt translate>payment.receiverInfo.address.street.label</dt>
        <dd>{{ payment.ultimateBeneficiaryStreetName }}</dd>
      </dl>
      <dl *ngIf="payment.ultimateBeneficiaryBuildingName">
        <dt translate>payment.receiverInfo.address.buildingName.label</dt>
        <dd>{{ payment.ultimateBeneficiaryBuildingName }}</dd>
      </dl>
      <dl *ngIf="payment.ultimateBeneficiaryBuildingNumber">
        <dt translate>payment.receiverInfo.address.buildingNumber.label</dt>
        <dd>{{ payment.ultimateBeneficiaryBuildingNumber }}</dd>
      </dl>
      <dl *ngIf="payment.ultimateBeneficiaryPostalCode">
        <dt translate>payment.receiverInfo.address.postalCode.label</dt>
        <dd>{{ payment.ultimateBeneficiaryPostalCode }}</dd>
      </dl>
    </app-collapse>
  </app-collapse>

  <app-collapse [headerKey]="'payment.receiverInfo.additionalBankIdentification.title'" *ngIf="payment.hasReceiverAdditionalBankInfo">
    <dl *ngIf="payment.additionalBeneficiaryBankCodeType">
      <dt translate>payment.receiverInfo.additionalBankIdentification.additionalBankIdentificationCodeType.label</dt>
      <dd>{{ payment.additionalBeneficiaryBankCodeType | bankCodeType }}</dd>
    </dl>

    <dl *ngIf="payment.additionalBeneficiaryBankCode">
      <dt translate>payment.receiverInfo.additionalBankIdentification.additionalBankIdentificationCode.label</dt>
      <dd>{{ payment.additionalBeneficiaryBankCode }}</dd>
    </dl>

    <dl *ngIf="payment.accountInBeneficiaryBank">
      <dt translate>payment.receiverInfo.accountInBeneficiaryBank.label</dt>
      <dd>{{ payment.accountInBeneficiaryBank }}</dd>
    </dl>
  </app-collapse>

  <app-collapse [headerKey]="'payment.additionalInformation'" *ngIf="payment.customFields?.length || payment.sourceOfIncome">
    <dl *ngIf="payment.sourceOfIncome">
      <dt translate>payment.receiverInfo.sourceOfIncome.label</dt>
      <dd *ngIf="isTranslatable(payment.sourceOfIncome, SourceOfIncome); else untranslatedSourceOfIncome">
        {{ 'payment.receiverInfo.sourceOfIncome.classifier.' + payment.sourceOfIncome | translate: locale.language }}
      </dd>
      <ng-template #untranslatedSourceOfIncome>
        <dd>{{ payment.sourceOfIncome }}</dd>
      </ng-template>
    </dl>
    <dl *ngFor="let customField of payment.customFields">
      <ng-container *ngIf="isTranslatable(customField.label, RoutingCodes); else untranslatedSourceOfIncome">
        <dt>{{ ('payment.receiverInfo.routingCode.' + customField.label) | translate: locale.language }}</dt>
      </ng-container>
      <ng-template #untranslatedSourceOfIncome> <dt>{{customField.label}}</dt> </ng-template>
      <dd>{{ customField.value }}</dd>
    </dl>
  </app-collapse>
</div>

<ng-template #beneficiaryIdentificationBlock>
  <app-payment-additional-info-identification
    [identification]="payment.beneficiaryIdentification"
    [identificationType]="payment.beneficiaryIdentificationType"
    [identificationCodeType]="payment.beneficiaryIdentificationCodeType"
    [identificationCode]="payment.beneficiaryIdentificationCode"
    [id]="payment.beneficiaryId"
    [birthDate]="payment.beneficiaryBirthDate"
    [countryOfBirth]="payment.beneficiaryCountryOfBirth"
    [provinceOfBirth]="payment.beneficiaryProvinceOfBirth"
    [cityOfBirth]="payment.beneficiaryCityOfBirth"
    [identificationName]="payment.beneficiaryIdentificationName"
    [identificationSurname]="payment.beneficiaryIdentificationSurname"
    [identificationDocument]="payment.beneficiaryIdentificationDocument"
  ></app-payment-additional-info-identification>
</ng-template>
